import { useContext, useMemo, forwardRef } from 'react'
import { Container, Hidden, Inline } from '@leroy-merlin-br/backyard-react-ui'

import { Breadcrumb as BaseBreadcrumb } from 'reactSite/Breadcrumb'

import { EntryKeyContext } from '../../context/EntryKeyContext'
import { Icon } from './components/Icon'
import { ShareButton } from './components/ShareButton'
import { Space } from '../Space'
import * as S from './styled'

const BreadcrumbBar = forwardRef((props, ref) => {
  const {
    apiDomain,
    categoryId,
    query: { term },
    isSearch,
    toggleMobileFilter
  } = useContext(EntryKeyContext)

  const nodes = useMemo(() => {
    if (isSearch) {
      return [
        {
          id: '1',
          name: 'Home',
          url: '/'
        },
        {
          id: '2',
          name: `Busca: ${term?.value}`,
          url: window.location.href
        }
      ]
    }
  }, [term, isSearch])

  return (
    <S.BreadcrumbBar ref={ref}>
      <Container>
        <Space>
          <S.Wrapper>
            <BaseBreadcrumb
              categoryId={categoryId}
              basehost={apiDomain}
              nodes={nodes}
            />

            <Hidden giga tera>
              <Inline spacing="mega">
                <ShareButton />
                <S.FilterButton
                  variant="ghost"
                  size="kilo"
                  label="filtrar"
                  onClick={toggleMobileFilter}
                >
                  <Icon name="filter" />
                </S.FilterButton>
              </Inline>
            </Hidden>
          </S.Wrapper>
        </Space>
      </Container>
    </S.BreadcrumbBar>
  )
})

export default BreadcrumbBar
